/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */

import { withLazyLoader } from "components/ui/LazyLoader";

export const ErrorPage = withLazyLoader(() => import("./404"));
export const ServerError = withLazyLoader(() => import("./500"));
export const UnAuthorized = withLazyLoader(() => import("./401"));
export const HomePage = withLazyLoader(() => import("./HomePage"));
export const Statistics = withLazyLoader(() => import("./Statistics"));

export const Analytics = withLazyLoader(() => import("./Analytics"));
export const StaffRoles = withLazyLoader(() => import("./StaffRoles"));
export const WebPages = withLazyLoader(() => import("./WebPages"));

export const OrderMetrics = withLazyLoader(
  () => import("./OrderMetrics/OrderMetrics"),
);

export { default as ErrorBoundaryPage } from "./ErrorBoundary";
